import api from '../api';
import Pessoa, { PessoasDisponibilidadeResponse } from '../model/Pessoa';

export default class PessoaViewModel {

  // GET all pessoas
  static async getPessoas(params?: { mostrarInativo: boolean, isMembroCavu?: boolean, processoId?: string, bancaId?: string }): Promise<Pessoa[]> {
    try {
      const { mostrarInativo, isMembroCavu, processoId, bancaId } = params || {}
      const response = await api.get<Pessoa[]>('/pessoas', { params: { mostrarInativo, isMembroCavu, processoId, bancaId } });
      return response.data;
    } catch (error) {
      console.error('Error fetching pessoas:', error);
      throw error;
    }
  }

  // POST a new pessoa
  static async createPessoa(pessoaData: Omit<Pessoa, 'id'>): Promise<Pessoa> {
    try {
      const response = await api.post<Pessoa>('/pessoas', pessoaData);
      return response.data;
    } catch (error) {
      console.error('Error creating pessoa:', error);
      throw error;
    }
  }

  // POST multiple pessoas
  static async createPessoaList(pessoasData: Omit<Pessoa, 'id'>[]): Promise<Pessoa[]> {
    try {
      const response = await api.post<Pessoa[]>('/pessoas/lote', pessoasData);
      return response.data;
    } catch (error) {
      console.error('Error creating pessoa list:', error);
      throw error;
    }
  }

  // GET pessoa by ID
  static async getPessoaById(id: string): Promise<Pessoa> {
    try {
      const response = await api.get<Pessoa>(`/pessoas/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching pessoa by ID:', error);
      throw error;
    }
  }

  // GET pessoa by Matricula
  static async getPessoaByMatricula(matricula: string): Promise<Pessoa> {
    try {
      const response = await api.get<Pessoa>(`/pessoas/matricula/${matricula}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching pessoa by ID:', error);
      throw error;
    }
  }

  // PATCH pessoa by ID
  static async updatePessoaById(id: string, pessoaData: Partial<Omit<Pessoa, 'id'>>): Promise<Pessoa> {
    try {
      const response = await api.patch<Pessoa>(`/pessoas/${id}`, pessoaData);
      return response.data;
    } catch (error) {
      console.error('Error updating pessoa by ID:', error);
      throw error;
    }
  }

  // GET pessoas não vinculadas a uma banca
  static async getPessoasNaoVinculadasABanca(processoId: string, bancaId: string): Promise<Pessoa[]> {
    try {
      const response = await api.get<Pessoa[]>(`/pessoas/processo/${processoId}/notbanca/${bancaId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching pessoas não vinculadas a banca:', error);
      throw error;
    }
  }

  static async updatePessoaAtivo(id: string, ativo: boolean) {
    try {
      const response = await api.patch<Pessoa>(`/pessoas/${id}/ativo`, { ativo });
      return response.data;
    } catch (error) {
      console.error('Error updating pessoa by ID:', error);
      throw error;
    }
  }

  // GET pessoas organizadas por seções de papel
  static async getPessoasDisponibilidadePorSecoes(processoId: string, bancaId: string): Promise<PessoasDisponibilidadeResponse> {
    try {
      const response = await api.get<PessoasDisponibilidadeResponse>('/pessoas/disponibilidade-secoes', {
        params: { processoId, bancaId }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching pessoas por seções:', error);
      throw error;
    }
  }

  static async searchPessoas(filtros: {
    nome?: string;
    email?: string;
    telefone?: string;
    vinculo?: string;
    mostrarInativo?: boolean;
    isMembroCavu?: boolean;
  }, page: number = 0, size: number = 10) {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
        sort: 'nome,asc'
      });

      if (filtros.nome) params.append('nome', filtros.nome);
      if (filtros.email) params.append('email', filtros.email);
      if (filtros.telefone) params.append('telefone', filtros.telefone);
      if (filtros.vinculo) params.append('vinculo', filtros.vinculo);
      if (filtros.mostrarInativo !== undefined) params.append('mostrarInativo', filtros.mostrarInativo.toString());
      if (filtros.isMembroCavu !== undefined) params.append('isMembroCavu', filtros.isMembroCavu.toString());

      const response = await api.get(`/pessoas/search?${params}`);
      
      return {
        content: response.data._embedded?.pessoaResponseList || [],
        pageMetadata: {
          totalElements: response.data.page?.totalElements || 0,
          totalPages: response.data.page?.totalPages || 0,
          size: response.data.page?.size || size,
          number: response.data.page?.number || page
        }
      };
    } catch (error) {
      console.error('Error searching pessoas:', error);
      throw error;
    }
  }
}
